import { useLocalStorage } from '../../hooks/useLocalStorage/useLocalStorage';
import { DateTime } from 'luxon';
export var filterStateKey = 'filter-state-sma';
export var usePersistedShiftFilters = function (props) {
    var localStorage = useLocalStorage({
        key: filterStateKey,
        employeeId: props.employeeId
    });
    var loadFilterState = function () {
        var _a, _b;
        var raw = localStorage === null || localStorage === void 0 ? void 0 : localStorage.load();
        if (raw) {
            var startTime = (_a = raw.shiftTime) === null || _a === void 0 ? void 0 : _a.startTime;
            var endTime = (_b = raw.shiftTime) === null || _b === void 0 ? void 0 : _b.endTime;
            if (!raw.shiftTime) {
                raw.shiftTime = {};
            }
            if (startTime) {
                raw.shiftTime.startTime = DateTime.fromISO(startTime);
            }
            if (endTime) {
                raw.shiftTime.endTime = DateTime.fromISO(endTime);
            }
        }
        return raw;
    };
    var save = function (data) {
        if (localStorage) {
            localStorage.save(data);
        }
    };
    return {
        loadFilterState: loadFilterState,
        storeFilterState: save
    };
};
